<template>
  <component :is="component"></component>
</template>
<script>

import Func10Listagem from '@/views/10/Func10Listagem'

export default {
  name: 'Func10',
  data () {
    return {
      component: Func10Listagem
    }
  }
}
</script>
